export const RadiusStyles = {
   base: {
      value: '0.625rem',
   },
};

export const ColorStyles = {
   brand: {
      value: '#F5E876',
      description: 'Light Yellow',
   },
   primary: {
      value: '#013C58',
      description: 'Dark Blue',
   },
   background: {
      value: '#121212',
      description: 'Light Black',
   },
   lightBackground: {
      value: '#2D2D2D',
      description: 'Light Background',
   },
   greyBg: {
      value: '#8F8D76',
      description: 'Grey Bg',
   },
   black: {
      value: '#000000',
      description: 'Black',
   },
   darkGray: {
      value: '#B5B5B5',
      description: 'Gray',
   },
   lightGray: {
      value: '#1513040D',
      description: 'Light Gray',
   },
   brightBlue: {
      value: '#3C63DF',
      description: 'Bright Blue',
   },
   white: {
      value: '#FFFFFF',
      description: 'White',
   },
   error: {
      value: '#FF0000',
      description: 'Error',
   },
   darkerBtn: {
      value: '#222A31',
      description: 'Dark Btn',
   },
};

export const LetterSpacingStyles = {
   xs: {
      value: '0.006rem', // 1%
   },
   xs_1: {
      value: '-0.006rem', // -1%
   },
   sm: {
      value: '0.013rem', // 2%
   },
   sm_1: {
      value: '-0.013rem', // -2%
   },
   md: {
      value: '0.019rem', // 3%
   },
   md_1: {
      value: '-0.019rem', // -3%
   },
};

export const FontSizeStyles = {
   xs: {
      value: '0.75rem', //12px,
   },
   sm: {
      value: '0.875rem', // 14px
   },
   md: {
      value: '1rem', //16px
   },
   lg: {
      value: '1.125rem', // 18px
   },
   xl: {
      value: '1.25rem', // 20px
   },
   '2xl': {
      value: '1.375rem', // 22px
   },
   '3xl': {
      value: '1.5rem', //24px
   },
   '4xl': {
      value: '1.75rem', //28px
   },
   '5xl': {
      value: '2rem', // 32px
   },
   '6xl': {
      value: '2.125rem', //34px
   },
   '7xl': {
      value: '3rem', // 48px
   },
   '8xl': {
      value: '3.5rem', //56px
   },
   '9xl': {
      value: '4rem', // 64px
   },
   '10xl': {
      value: '4.5rem', // 72px
   },
   '11xl': {
      value: '7.813rem', // 125px
   },
   '12xl': {
      value: '2.5rem', // 40px
   },
};
